// extracted by mini-css-extract-plugin
export default {"popup_container":"PopUp_popup_container__iBTq0","body":"PopUp_body__Ss0KG","closeButton":"PopUp_closeButton__Jhkrq","button_container":"PopUp_button_container__pQU2y"};